const SUSPECT_TAGS = 'style, script, iframe';

/**
 * Creates a div element and strip all suspect tags that are specified in the SUSPECT_TAGS constant
 * @param  {String} content the html content
 * @return {String}         the inner html wrapped in a div
 */
const createDivElementAndStripSuspectTags = content => {
  const div = document.createElement('div');
  div.innerHTML = content;
  div.querySelectorAll(SUSPECT_TAGS).forEach(el => el.remove());
  return div;
};

/**
 * This filter removes style, script, and iframe tags from the data before
 * rendering it on the screen.
 * @param  {String} content the html content to sanitize
 * @return {String}         the sanitized html
 */
const safeHTML = content => {
  if (!content) {
    return '';
  }
  const div = createDivElementAndStripSuspectTags(content);
  return div.innerHTML;
};

/**
 * Extracts out the plain text from the innerHTML and
 * optionally truncates the text longer than given length
 * @param  {String} content the html content to sanitize
 * @return {String}         the sanitized plain text
 */
const safePlainText = (content, truncateAfterLength) => {
  if (!content) {
    return '';
  }
  const div = createDivElementAndStripSuspectTags(content);
  const text = div.textContent || div.innerText || '';
  if (!truncateAfterLength) {
    return text;
  }
  if (text.length > truncateAfterLength) {
    return `${text.substring(0, truncateAfterLength)}...`;
  }
  return text;
};

export {
  safeHTML,
  safePlainText,
};
